import { DecimalPipe } from '@angular/common';
import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import type { OnyxOptional, OnyxSuggestion } from '@onyx/angular';
import type { UnitRuleField } from '../constants/common/unit-rules';
import { UNIT_RULES } from '../constants/common/unit-rules';
import { UnitWarningHelper } from '../helpers/unit-warning.helper';

@Pipe({
  name: 'unitSuggestions',
})
export class UnitSuggestionsPipe implements PipeTransform {
  private readonly decimalPipe = inject(DecimalPipe);

  public transform(
    value: OnyxOptional<number>,
    field: UnitRuleField,
  ): OnyxSuggestion<number>[] | null {
    const suggestion = UnitWarningHelper.getWarning(value, field)?.suggestion;
    if (suggestion == null) return null;

    return [
      {
        name: `${UnitWarningHelper.format(suggestion, field, this.decimalPipe)} ${UNIT_RULES[field].unit}`,
        value: suggestion,
      },
    ];
  }
}
